import React from "react";
import { X } from "lucide-react";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase";
import { useAppContext } from "../../context/AppContext";

export default function AddServiceModal({
  setShowAddServiceForm,
  userCoords,
}: any) {
  const { t, user, activePet } = useAppContext();
  const mapCenterObj = { coords: [50.4501, 30.5234] };

  const handleCreateService = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!user) return;
    const fd = new FormData(e.currentTarget);
    await addDoc(collection(db, "services"), {
      title: fd.get("title") as string,
      price: fd.get("price") as string,
      description: fd.get("description") as string,
      author: activePet.name,
      authorPhoto: activePet.photo || null,
      userId: user.uid,
      coords: userCoords || mapCenterObj.coords,
      authorBreed: activePet.breed || "",
      authorGender: activePet.gender || "",
      authorDob: activePet.dob || "",
      createdAt: serverTimestamp(),
    });
    setShowAddServiceForm(false);
  };

  return (
    <div className="fixed inset-0 bg-black/60 z-[400] flex flex-col justify-end backdrop-blur-sm">
      <div className="bg-[var(--bg-card)] rounded-t-[2.5rem] p-6 pb-[100px] border-t border-[var(--border-color)]">
        <div className="flex justify-between items-center mb-6">
          <h3 className="font-extrabold text-xl text-[var(--text-main)]">
            {t.modOfferSvc}
          </h3>
          <button
            onClick={() => setShowAddServiceForm(false)}
            className="text-[var(--text-main)]"
          >
            <X size={20} />
          </button>
        </div>
        <form onSubmit={handleCreateService} className="flex flex-col gap-4">
          <div>
            <label className="text-xs font-bold text-[var(--text-muted)] uppercase block mb-2">
              {t.modSvcName}
            </label>
            <input
              name="title"
              required
              className="w-full h-12 px-4 bg-[var(--bg-soft)] border border-[var(--border-color)] text-[var(--text-main)] rounded-xl outline-none"
            />
          </div>
          <div>
            <label className="text-xs font-bold text-[var(--text-muted)] uppercase block mb-2">
              {t.modPrice}
            </label>
            <input
              name="price"
              required
              className="w-full h-12 px-4 bg-[var(--bg-soft)] border border-[var(--border-color)] text-[var(--text-main)] rounded-xl outline-none"
            />
          </div>
          <div>
            <label className="text-xs font-bold text-[var(--text-muted)] uppercase block mb-2">
              {t.modSvcDesc}
            </label>
            <textarea
              name="description"
              required
              className="w-full p-4 bg-[var(--bg-soft)] border border-[var(--border-color)] text-[var(--text-main)] rounded-xl outline-none min-h-[100px]"
            />
          </div>
          <button
            type="submit"
            className="w-full h-14 bg-[#a073e7] text-white font-bold rounded-xl mt-4 shadow-lg"
          >
            {t.publish}
          </button>
        </form>
      </div>
    </div>
  );
}
